import { useToast } from "../../hooks/use-toast.hook";
import React from "react";
import { Modal } from "../modal.component";
import I18 from "../atoms/i18";
import IconButton2 from "../icon-button-2-component";

type Option = {
    label: string,
    value: string,
}
type Props = {
    active?: boolean;
    setActive: (arg0: boolean) => void;
    options: Option[],
    selectedOption?: Option | undefined;
    setSelectedOption: React.Dispatch<React.SetStateAction<Option | undefined>>;
    onChange?: (option: Option | undefined) => void;
}

export function OptionSelectorModal({
    active,
    setActive,
    options = [],
    selectedOption,
    setSelectedOption,
    onChange,
}: Props) {
    const { addToast } = useToast();

    return (
        <Modal
            active={active}
            setActive={setActive}
            overflow=""
            padding={false}
            width="300px">
            <div className="bg-card">
                <div className="flex items-center justify-between border-b border-border px-4 py-2 text-sm">
                    <p className="text-md font-bold">
                        <I18>Select</I18>{" "}
                    </p>
                    <IconButton2
                        icon="cross"
                        hoverable
                        size="md"
                        onClick={() => {
                            setActive(false);
                        }}
                    />
                </div>
                <div className="py-2">
                    {options?.map((option) => {
                        return (
                            <div
                                key={option.value}
                                className="mb-1 px-4 py-2 justify-center rounded-2xl hover:cursor-pointer w-full"
                                onClick={() => {
                                    onChange && onChange(option);
                                }}>
                                {option.label}
                            </div>
                        );
                    })}
                </div>
            </div>
        </Modal>
    );
}